export default __webpack_public_path__ + "static/media/Dental.b6607221.svg";